module.exports = __webpack_public_path__ + "img/en.25723383.png";